import script from "./MainLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainLayout.vue?vue&type=script&setup=true&lang=ts"

import "./MainLayout.vue?vue&type=style&index=0&id=6fe60ce9&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fe60ce9"]])

export default __exports__